import translations, { ICombinedTranslations } from '../translations';

export interface IBaseError {
  missing: string;
}

export interface IErrorWithValidation extends IBaseError {
  invalid: string;
}

export interface IComponentWithoutValidation {
  bankIntegration?: IBaseError;
  termsAgreement?: IBaseError;
  loanPurpose?: IBaseError;
  cardPurpose?: IBaseError;
  cardPurposeAdditionalInfo?: IBaseError;
  documentUpload?: IBaseError;
  turnover?: IBaseError;
  website?: IBaseError;
  houseNumber?: IBaseError;
}
export interface IComponentWithValidation {
  loanAmount?: IErrorWithValidation;
  orgNumber?: IErrorWithValidation;
  loanTerm?: IErrorWithValidation;
  emailAddress?: IErrorWithValidation;
  personalNumber?: IErrorWithValidation;
  phoneNumber?: IErrorWithValidation;
  homeAddress?: IErrorWithValidation;
  postCode?: IErrorWithValidation;
  houseNumberAddition?: IErrorWithValidation;
}

export interface IErrorMessages extends IComponentWithValidation, IComponentWithoutValidation {
  serverError: string;
  default: string;
}

export const getErrorMessage = (
  locale: keyof ICombinedTranslations,
  errorName: keyof IErrorMessages
) => {
  try {
    return translations[locale].error[errorName] || translations[locale].error.default;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn(
      `Error in getErrorMessage. Tried to access the error with:\n Locale: ${locale}\n Component Name: ${errorName}\nError was this:`,
      error
    );
    return translations['en-SE'].error[errorName] || translations['en-SE'].error.default;
  }
};

export const getServerError = (locale: keyof ICombinedTranslations) => {
  try {
    return translations[locale].error.serverError || translations['en-SE'].error.serverError;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn(
      `Error in getErrorMessage. Tried to access the server error with:\n Locale: ${locale}\nError was this:`,
      error
    );
    return translations['en-SE'].error.serverError;
  }
};
